module.exports = __webpack_public_path__ + "img/noData.e810bc32.png";